import { render, staticRenderFns } from "./Subtitle.vue?vue&type=template&id=7b83b0a6&scoped=true&"
import script from "./Subtitle.vue?vue&type=script&lang=ts&"
export * from "./Subtitle.vue?vue&type=script&lang=ts&"
import style0 from "./Subtitle.vue?vue&type=style&index=0&id=7b83b0a6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b83b0a6",
  null
  
)

export default component.exports